export default __webpack_public_path__ + "static/door_b.57d4fa25e39a24e55409172354016b27.svg";